import api from "../store/services/api";

export const getOrdersV2 = async (params) =>
  await api.get(`/orders/v2/`, {
    params,
  });

// Which of these orders need a card machine on dispatch, read from their
// payments on the server (the store's has_card can be stale).
export const getDispatchRequirements = async (orderIds) =>
  await api.get(`/orders/dispatch/requirements/`, {
    params: { oids: orderIds.join(",") },
  });

export const getNewOrderEvents = async (params) =>
  await api.get(`/orders/events/new/`, {
    params,
  });

export const getOrdersHistory = async (params) =>
  await api.get(`/orders/history/`, {
    params,
  });

export const getAvailableDeliveryOrders = async () =>
  await api.get(`/orders/delivery/`);

export const getOrdersHistoryReport = async (params) =>
  await api.get(`/orders/history/report/`, {
    params,
  });

export const getOrderDetail = async (params) =>
  await api.get(`/orders/detail/`, {
    params,
  });

export const getOrderPrintDetail = async (params) =>
  await api.get(`/orders/print/`, {
    params,
  });

export const getOrderSummaryMarkdown = async (params) =>
  await api.get(`/orders/summary/`, {
    params,
  });

export const getCancelledOrderDetail = async (orderId) =>
  await api.get(`/orders/${orderId}/cancelled/`);

export const createNewOrder = async (newOrder) =>
  await api.post("/pos/order/", newOrder);

export const createNewSaloonTableOrder = async (newOrder) =>
  await api.post("/pos/order/saloon/", newOrder);

export const orderPoll = async (params) =>
  await api.get(`/pos/order/poll/`, {
    params,
  });

export const finishOrder = async (orderChannel, orderChannelOrderId) =>
  await api.get(
    "action/?platform=" +
      orderChannel +
      "&action=finish&orderId=" +
      orderChannelOrderId
  );

export const actionOrder = async (orderChannel, orderChannelOrderId, action) =>
  await api.get(
    `action/?platform=${orderChannel}&action=${action}&orderId=${orderChannelOrderId}`
  );

export const extraDelivery = async ({ orderId, driver_id, reason }) =>
  await api.post(`/orders/${orderId}/delivery/extra/`, {
    driver_id,
    reason,
  });

export const cancelOrder = async (
  orderChannel,
  orderChannelOrderId,
  code,
  reason
) =>
  await api.get(
    "action/?platform=" +
      orderChannel +
      "&action=cancel&orderId=" +
      orderChannelOrderId +
      "&cancelCode=" +
      code +
      "&cancelReason=" +
      reason
  );

export const ordersReport = async (params) =>
  await api.get(`/orders/report/`, {
    params,
  });

export const handleOrderProductsCreateEdit = async (orderId, orderProduct) =>
  await api.post(`/pos/order/${orderId}/product/`, orderProduct);

export const ordersEventsTimeline = async (params) =>
  await api.get(`/report/orders/events/timeline/`, {
    params,
  });

export const ordersEventsDriverAvailability = async (params) =>
  await api.get(`/report/orders/events/driver-availability-analysis/`, {
    params,
  });

export const ordersEventsTimePattern = async (params) =>
  await api.get(`/report/orders/events/time-pattern-analysis/`, {
    params,
  });

export const sendOrderCustomerToBlacklist = async (orderId) => {
  return await api.put(
    `/orders/${orderId}/customer/blacklist/`,
    {},
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

const OrderService = {
  getOrders: getOrdersHistory,
  orderPoll,
  getOrderDetail,
  getCancelledOrderDetail,
  createNewOrder,
  actionOrder,
  finishOrder,
  cancelOrder,
  ordersReport,
  handleOrderProductsCreateEdit,
  extraDelivery,
  ordersEventsTimeline,
  ordersEventsDriverAvailability,
  ordersEventsTimePattern,
  sendOrderCustomerToBlacklist,
};

export default OrderService;
